import Services from '@/components/services'

const routers = [
  {
    path: 'hotels',
    name: 'HotelsSearch',
    component: Services.Hotels.Search
  },
]

export default routers